'use client';
import { Modal } from '@ethsign/ui';

import { globalVm } from '@/pages/GlobalPageCtrl';

export const BeraChainModal = ({ open, onOpenChange }: { onOpenChange: (open: boolean) => void; open: boolean }) => {
  return (
    <>
      <Modal
        open={open}
        onOpenChange={onOpenChange}
        hiddenCloseIcon
        maskClosable={false}
        footer={<div />}
        className={'max-w-[100vw] max-h-[100vh] bg-transparent p-0'}
      >
        <div className="flex items-center flex-col justify-end relative h-[100vh]">
          <img
            className="w-[100vw]  inline-block  absolute left-0 top-0"
            src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/bera-bg_240723074929.webp"
            onLoad={() => {
              setTimeout(() => {
                globalVm.toggleBeraChainModal(false);
              }, 3000);
            }}
          ></img>
          {/* <img
            className="inline-block relative z-10 w-[50vw]"
            src="https://ethsign-public.s3.ap-east-1.amazonaws.com/signatures-next/Bear-high-res_240410025144.gif"
            onLoad={() => {
              setTimeout(() => {
                globalVm.toggleBeraChainModal(false);
              }, 3000);
            }}
          ></img> */}
        </div>
      </Modal>
    </>
  );
};
